import { FC } from "react";
import { version } from "../../../package.json";

const Header: FC = () => {
    return (
        <header
            className="header-image"
            style={{
                backgroundImage:
                    "url(https://geoweb.software/wp-content/uploads/sites/17/2016/03/GeoWeb-homepage.png)",
                height: "385px",
            }}
        >
            <div className="content-a">
                <div className="content-b">
                    <div className="container" id="header-container">
                        <h1>
                            GeoWeb Extensie Overzicht
                            <span className="version">v{version}</span>
                        </h1>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
